// KOMOJU 특상법(SCTA) 심사에 쓰는 점포·연락처·가격 표기.
// 신청서·특상법 페이지·prints 화면이 같은 값을 보도록 한곳에서만 정의한다.

export const PRINTS_SHOP_NAME = 'すくすくぱしゃ';
export const PRINTS_COMPANY_NAME = 'JEJEMEME Inc.';
export const PRINTS_REPRESENTATIVE_NAME = 'Jewoo Jeon';
export const PRINTS_CONTACT_EMAIL = 'md@jejememe.com';
export const PRINTS_CONTACT_PHONE = '+82 10-2940-1803';
export const PRINTS_CONTACT_PHONE_HREF = 'tel:+821029401803';
export const PRINTS_STORE_URL = 'https://mypage.babyfolio.net/prints';
export const PRINTS_SHIPPING_MIN_JPY = 3000;
export const PRINTS_SHIPPING_MAX_JPY = 5000;
export const PRINTS_DEFAULT_UNIT_PRICE_JPY = 20;
export const PRINTS_DEFAULT_MIN_COUNT = 35;

export const formatPrintsJpy = (value: number): string => `¥${value.toLocaleString('ja-JP')}`;

const copySearchParams = (search: string): URLSearchParams => new URLSearchParams(search);

export const getPrintsTokushoHref = (): string => {
  if (typeof window === 'undefined') return '/prints/tokusho';

  const params = copySearchParams(window.location.search);
  if (params.get('page') === 'prints' || params.get('page') === 'prints-contact') {
    params.set('page', 'prints-tokusho');
    const query = params.toString();
    const pathname = window.location.pathname === '/prints' ? '/' : window.location.pathname;
    return `${pathname}${query ? `?${query}` : ''}`;
  }

  params.delete('page');
  const query = params.toString();
  return `/prints/tokusho${query ? `?${query}` : ''}`;
};

export const getPrintsContactHref = (): string => {
  if (typeof window === 'undefined') return '/prints/contact';

  const params = copySearchParams(window.location.search);
  if (params.get('page') === 'prints' || params.get('page') === 'prints-tokusho') {
    params.set('page', 'prints-contact');
    const query = params.toString();
    const pathname = window.location.pathname === '/prints' ? '/' : window.location.pathname;
    return `${pathname}${query ? `?${query}` : ''}`;
  }

  params.delete('page');
  const query = params.toString();
  return `/prints/contact${query ? `?${query}` : ''}`;
};

export const getPrintsHomeHref = (): string => {
  if (typeof window === 'undefined') return '/prints';

  const params = copySearchParams(window.location.search);
  if (params.get('page') === 'prints-tokusho' || params.get('page') === 'prints-contact') {
    params.set('page', 'prints');
    const query = params.toString();
    return `${window.location.pathname}${query ? `?${query}` : ''}`;
  }

  params.delete('page');
  const query = params.toString();
  return `/prints${query ? `?${query}` : ''}`;
};

export const isPrintsTokushoPath = (pathname: string): boolean => {
  const normalized = pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
  return normalized === '/prints/tokusho';
};

export const isPrintsContactPath = (pathname: string): boolean => {
  const normalized = pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
  return normalized === '/prints/contact';
};

export const hasPrintsTokushoPageQuery = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('page') === 'prints-tokusho';
  } catch {
    return false;
  }
};

export const hasPrintsContactPageQuery = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('page') === 'prints-contact';
  } catch {
    return false;
  }
};
